
import { useAuth } from '@common/auth/use-auth';
import {Trans} from '@common/i18n/trans';
import { useTrans } from '@common/i18n/use-trans';
import { Button } from '@common/ui/buttons/button';
import React, {Fragment, ReactNode, useEffect, useState} from 'react';
import { FormTextField, TextField } from '@common/ui/forms/input-field/text-field/text-field';
import {Item} from '@common/ui/forms/listbox/item';

import {FieldValues, SubmitHandler, UseFormReturn, useForm} from 'react-hook-form';
import {Form} from '@common/ui/forms/form';
import { useMyLenders } from '@app_modules/admin/lenders/requests/use-my-lenders';
import { FormSelect } from '@common/ui/forms/select/select';
import { Lender } from '@app_modules/lenders/lender';
import { useDemoChat } from '../requests/use-demo-chat';
import { Prompt } from '@app_modules/chats/prompt';


export function ChatNowPage({changeLender}: any) {
  const {trans} = useTrans();
  const {user} = useAuth();
  
  const [newMessage, setNewMessage] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    setMessage(newMessage);
  }, [newMessage])


  return (
    <Fragment>
      <div className='flex gap-10 m-20'>
        <div className='w-[30%] pr-10 border-r-1 sticky'>
          <AddPrompt newMessage={setNewMessage} changeLender={changeLender}/>
        </div>
        <div className='w-[70%]'>
          {/* <ChatCustomPage message={message} chat={query.data.chat}/> */}
          
          <TextField
              className='form-input'
              name='message'
              value={message ? message : ''}
              inputElementType="textarea"
              rows={28}
              onChange={e => {
                
              }}             
            />
        </div>
      </div>
      
    </Fragment>
  );
}


function AddPrompt({newMessage, changeLender}:{newMessage: any, changeLender: any}) {

  const form = useForm<Prompt>({
    defaultValues: {
    },
  });
  const sendChat = useDemoChat(form);

  return (
    <AddPromptForm
      form={form}
      onSubmit={values => {
        sendChat.mutate(values, 
          {
            onSuccess: (response:any) => {
              newMessage(response.data);
            },

        });
      }}
      isLoading={sendChat.isPending}
      changeLender={changeLender}
    >
    </AddPromptForm>
  );

}

interface Props<T extends FieldValues> {
  onSubmit: SubmitHandler<T>;
  form: UseFormReturn<T>;
  isLoading: boolean;
  disableSaveWhenNotDirty?: boolean;
  changeLender: any;
}
export function AddPromptForm<T extends FieldValues>({
  onSubmit,
  form,
  isLoading = false,
  disableSaveWhenNotDirty = false,
  changeLender
}: Props<T>) {
  const isDirty = !disableSaveWhenNotDirty
    ? true
    : Object.keys(form.formState.dirtyFields).length;

  const {data: mylenders} = useMyLenders();
  const lenders = mylenders?.lenders;

  return (
    <Form
      onSubmit={onSubmit}
      onBeforeSubmit={() => form.clearErrors()}
      form={form}
    >
      <div className='flex flex-wrap'>
        <div className='items-center text-xs w-[100%]'>
          <FormSelect
            name="lender_id"
            selectionMode="single"
            required
            autoFocus={true}
            label={<Trans message="Lender" />}
            className="mb-20"
            onSelectionChange={val => {
              changeLender(val.toString());
            }}
          >
            {lenders?.map((lender: Lender) => (
            <Item value={lender.id} key={lender.id}>
              <Trans message={lender.workspace_name} />
            </Item>
            ))}
          </FormSelect>
          <FormTextField
            className='form-input '
            inputElementType="textarea"
            rows={28}
            name='prompt'
            placeholder='Enter your prompt'
            // onChange={e => setPrompt(e.target.value)}             
          />
        </div>
        <div className='text-xs w-full m-10 justify-center'>
          <Button
              variant="flat"
              color="green"
              type="submit"
              disabled={isLoading || !isDirty}
            >
              <Trans message="Send" />
          </Button>
        </div>  
      </div>
    </Form>
  );
}

